export default {
	properties: [
		{
			text: 'Id',
			key: 'meli_order_id',
			type: 'text',
			only_show: true,
		},
		{
			text: 'Estado',
			key: 'status',
			type: 'text',
			only_show: true,
		},
		{
			text: 'Detalle Estado',
			key: 'status_detail',
			type: 'text',
			only_show: true,
		},
		{
			text: 'Creado',
			key: 'meli_created_at',
			type: 'date',
			only_show: true,
			is_date: true,
		},
		{
			text: 'Cerrado',
			key: 'meli_closed_at',
			type: 'date',
			only_show: true,
			is_date: true,
		},
		// Estado interno (pendiente / confirmado): al pasar a Confirmado con pago ML "paid" se genera la venta.
		{
			text: 'Gestion',
			key: 'meli_order_status_id',
			type: 'select',
			use_store_models: true,
			show: true,
		},
		// Depósito / dirección de stock al confirmar (mismo criterio que Tienda Nube).
		{
			text: 'Deposito',
			key: 'address_id',
			type: 'select',
			use_store_models: true,
			select_prop_name: 'street',
			value: null,
			show: true,
		},
		{
			text: 'Notas',
			key: 'notes',
			type: 'textarea',
			value: '',
			show: true,
		},
		{
			text: 'Articulos',
			key: 'articles',
			type: '',
			only_show: true,
			store: 'article',
			belongs_to_many: {
				model_name: 'article',
				props_to_show: [
					{
						text: 'N°',
						key: 'num',
					},
					{
						text: 'Imagen',
						key: 'images',
						type: 'images',
					},
					{
						text: 'MeLi id',
						key: 'me_li_id',
					},
					{
						text: 'Nombre',
						key: 'name',
					},
				],
				pivot_props_to_show: [
					{
						text: 'Cantidad',
						key: 'amount',
					},
					{
						text: 'Precio',
						key: 'price',
						is_price: true,
					},
				],
			}
		},
		{
			text: 'Total',
			key: 'total',
			type: 'number',
			only_show: true,
			is_price: true,
		},
		{
			text: 'Comprador',
			key: 'meli_buyer_id',
			type: 'text',
			only_show: true,
			relation_prop_name: 'nickname',
		},
		// {
		// 	text: 'Medios de pago',
		// 	key: 'me_li_payments',
		// 	type: 'text',
		// 	has_many: {
		// 		text: 'Medio de pago',
		// 		model_name: 'me_li_payment',
		// 	}
		// },
	],
	singular_model_name_spanish: 'Pedido de Mercado Libre',
	plural_model_name_spanish: 'Pedidos de Mercado Libre',
	create_model_name_spanish: 'Nuevo Pedido de Mercado Libre',
	text_delete: 'el',
}
// {
    
//     "payments": [{
//    	 "id": "596707837",
//    	 "transaction_amount": 499,
//    	 "currency_id": "BRL",
//    	 "status": "approved",
//    	 "date_created": null,
//    	 "date_last_modified": null
//     }],
//     "feedback": {
//    	 "purchase": null,
//    	 "sale": null
//     },
//     "context": {
//      "channel": "marketplace",
//      "site": "MLB",
//      "flows": [
//      000]
//   },
//     "shipping": {
//    	 "id": 20676482441
//     },
//     "tags": [
//    	 "paid",
//    	 "not_delivered"
//     ]
// }